export default class BaseMarker {
  id = null;
  type = null;
  assetId = null;
  scanId = null;
  transform = null;
  eTag = null;
  meshGroup = null;

  constructor(id, type, assetId, scanId, transform, eTag){
    this.id = id;
    this.type = type;
    this.assetId = assetId;
    this.scanId = scanId;
    this.transform = transform;
    this.eTag = eTag;
  }
}